<template>
<div id="applications">
    <ApplicationCRU />
    <v-layout wrap justify-center>
        <v-flex>
            <v-toolbar flat>
                <v-toolbar-title>Applications</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn
                    outlined
                    class="drei_60-btn mb-2 mt-3 mr-1"
                    :disabled="loading"
                    @click="getApplications"
                >
                    neu laden
                </v-btn>
                <v-btn
                    outlined
                    class="drei_60-btn mb-2 mt-3 ml-1"
                    :disabled="loading"
                    @click="addApplication"
                >
                    hinzufügen
                </v-btn>
            </v-toolbar>
        </v-flex>
    </v-layout>
    <v-layout>
        <v-flex>
            <ApplicationsComponent />
        </v-flex>
    </v-layout>
</div>
</template>
<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import ApplicationsComponent from '@/components/application/Applications.vue';
import ApplicationCRU from '@/components/application/ApplicationCRU.vue';

export default {
    name: 'Applications',
    components: {
        ApplicationsComponent,
        ApplicationCRU,
    },
    computed: mapState('applications', ['loading']),
    methods: {
        ...mapActions('applications', ['getApplications']),
        ...mapMutations('applications', ['addApplication']),
    },
    mounted() {
        this.getApplications();
    },
};

</script>
<style scoped lang="scss"></style>
